import { Component, Input } from '@angular/core';

import { IWorkItemComponent } from '../models/work-item-component';

@Component({
  selector: 'app-page-optimization',
  templateUrl: './page-optimization.component.html',
  styleUrls: ['./page-optimization.component.css']
})
export class PageOptimizationComponent implements IWorkItemComponent {
  @Input() public value: any;
  @Input() public type: number;
}
